import { Link } from 'react-router-dom';

// Compact CARLENS brand hero used sitewide (home, locations, services, academy).
// Displays the official CarLens logo on a premium black backdrop.
export const BrandHero = () => {
  return (
    <section className="relative w-full overflow-hidden bg-black" data-testid="hero-banner">
      {/* Hex-like dot texture */}
      <div
        className="absolute inset-0 opacity-[0.14] pointer-events-none"
        style={{
          backgroundImage: 'radial-gradient(rgba(255,255,255,0.10) 1px, transparent 1px)',
          backgroundSize: '22px 22px',
        }}
      />
      {/* Orange lens arc */}
      <div
        className="pointer-events-none absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"
        style={{
          width: '80%',
          height: '150%',
          borderRadius: '50%',
          border: '2px solid rgba(249,115,22,0.5)',
          boxShadow: '0 0 70px rgba(249,115,22,0.22)',
        }}
      />
      {/* Center glow */}
      <div className="absolute top-1/3 left-1/2 -translate-x-1/2 w-[620px] h-[300px] bg-orange-500/15 blur-[130px] rounded-full pointer-events-none" />
      {/* Bottom fade into page */}
      <div className="absolute bottom-0 inset-x-0 h-20 bg-gradient-to-b from-transparent to-[#141416]" />

      <div className="relative z-10 max-w-6xl mx-auto px-6 pt-8 pb-8 md:pt-10 md:pb-10 text-center">
        <Link
          to="/"
          className="inline-block"
          aria-label="CarLens — Inspect. Inform. Protect. — Home"
          data-testid="hero-logo-home"
        >
          <img
            src="/carlens-logo.png"
            alt="CarLens — Inspect. Inform. Protect."
            className="w-full max-w-md sm:max-w-lg lg:max-w-2xl mx-auto h-auto"
            loading="eager"
            width="994"
            height="320"
          />
        </Link>
      </div>
    </section>
  );
};

export default BrandHero;
